var angular = require('angular');

export default angular.module('asEula', []).component('asEula', {
    template: require('./asEula.component.html'),
    styleUrls: require('./asEula.component.css'),
    controller: ['$timeout', asEulaComponent],
    bindToController: true,
    bindings: {
        ngModel: '=',
        eulaChange: '&'
    }
});

function asEulaComponent($timeout) {
    var vm = this;
    vm.$onInit = function() {
        vm.eulaLink = 'https://docs.appspace.com/faq/legal/customer-agreement/';
    };

    vm.click = function() {
        $timeout(function() {
            vm.eulaChange({ value: vm.ngModel });
        });
    };
}



// WEBPACK FOOTER //
// ./modules/shared/asEula/asEula.component.js